import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnifiedComponent } from './unified.component';
import { IntegrationComponent } from './integration/integration.component';
import { UnifiedRoutingModule } from './unified-routing.module';
import { SideNavbarModule } from '../sidenavbar.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IntegrationUnitComponent } from './integration-unit/integration-unit.component';
import { IntegrationCallbackComponent } from './integration-callback/integration-callback.component';
import { NgbAlertModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({ declarations: [UnifiedComponent, IntegrationComponent, IntegrationUnitComponent, IntegrationCallbackComponent],
    exports: [
        IntegrationComponent,
        UnifiedComponent
    ], imports: [CommonModule,
        UnifiedRoutingModule,
        SideNavbarModule,
        ReactiveFormsModule,
        FormsModule,
        NgbAlertModule,
        NgbProgressbarModule] })
export class UnifiedModule { }
